/* バリアント選択の計測（variant_select）— 全店共通の契約。正本 stride_corp/repos/business-hub/README.md「テーマ側の計測イベント variant_select」。
 * Drymax（Debut 17.12）: layout/theme.liquid の head（GTM 本体の直後）から defer で読む。LUNA の luna-variant-tracking.js と同一の実装（コメント以外は変えない）。
 *
 * 役割: PDP で「どのバリアント（カラー × サイズ）が、在庫のある / 無い状態で、初期表示され・選ばれたか」を GTM の dataLayer へ積む 1 本。
 *   - 読み込み時に初期表示バリアントを 1 回（variant_trigger = load）、以後バリアントが切り替わるたびに 1 回（select）。
 *     切替のうち直前とカラーが違うもの（サイズのオプションがある商品）は color（2026-10-14 契約追加）＝利用者がカラーを変え、サイズはテーマが先頭サイズ等へ付け替えた切替。
 *     RepOOS（在庫切れの状態で選ばれた率）は select だけで数える。カラーが同じでサイズが変わった切替・直前の無い切替は select。
 *   - 在庫状態・title・color・size は snippets/tracking-variant.liquid が埋める JSON（<script data-variant-stock>）から引く
 *     ＝テーマ JS の内部構造（Debut の変数や DOM）に依存しない。他店へもこの JS と snippet の組をそのまま持ち込む。
 *   - 切替の検知は URL フック（history.replaceState / pushState の `variant=` の変化・popstate）を土台に、テーマ系統ごとの通知イベント
 *     （Rise / Dawn: PUB_SUB_EVENTS.variantChange ／ Prestige・Impact・Impulse: variant:change ／ Horizon: variant:update ／
 *       Reformation: product:variant-change ／ Debut・Impulse: variantChange〔container・bubbles なし＝capture で拾う〕）を document の capture で重ねる。
 *     同じ ID が連続したら送らない（URL と通知イベントの二重・初期表示直後の同じバリアントの通知を畳む）。A → B → A は 3 回。
 *   - 送らないもの: page_view / view_item 等の標準イベント（送信元は全店共通の構成で決まっている）。クイックビュー・PLP カード上の選択は対象外。
 *   - テーマエディタ（Shopify.designMode）では何も送らない。Google のライブラリ（gtag）は直接呼ばない。
 */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var node = document.querySelector('script[data-variant-stock]');
  if (!node) return;
  var cfg;
  try {
    cfg = JSON.parse(node.textContent || '{}');
  } catch (e) {
    return;
  }
  var variants = (cfg && cfg.variants) || {};
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  var MAX_LEN = 100;
  var last = null;
  function cap(value) {
    var s = String(value == null ? '' : value);
    return s.length > MAX_LEN ? s.slice(0, MAX_LEN) : s;
  }
  function send(id, trigger) {
    id = String(id == null ? '' : id);
    var v = variants[id];
    if (!v || id === last) return;
    /* 切替のうち、直前のバリアントとカラーが違い、かつサイズのオプションがある商品のもの＝利用者がカラーを変え、サイズはテーマが付け替えた（先頭サイズ等）
       → color（2026-10-14 契約追加・RepOOS の分母 / 分子に数えない）。カラーが同じ（サイズを選んだ）・直前が無い・カラーかサイズのオプションが無い商品は select のまま */
    if (trigger === 'select' && last != null && variants[last] && variants[last].c !== v.c && v.s !== '') trigger = 'color';
    last = id;
    dataLayer.push({
      event: 'variant_select',
      variant_trigger: trigger,
      variant_id: id,
      variant_title: cap(v.t),
      variant_color: cap(v.c),
      variant_size: cap(v.s),
      variant_available: v.a ? 'true' : 'false',
    });
  }
  function fromUrl() {
    try {
      var m = /[?&]variant=(\d+)/.exec(window.location.search || '');
      if (m) send(m[1], 'select');
    } catch (e) {
      /* noop */
    }
  }
  function fromDetail(e) {
    var d = e && e.detail;
    if (!d) return;
    var v = d.variant || d.resource || (d.data && d.data.variant);
    if (v && v.id != null) send(v.id, 'select');
  }
  /* 1) 初期表示 */
  if (cfg.selected) send(cfg.selected, 'load');
  /* 2) URL フック（全系統の土台） */
  ['pushState', 'replaceState'].forEach(function (k) {
    var orig = window.history[k];
    if (typeof orig !== 'function') return;
    window.history[k] = function () {
      var r = orig.apply(this, arguments);
      fromUrl();
      return r;
    };
  });
  window.addEventListener('popstate', fromUrl);
  /* 3) テーマ系統の通知イベント（document の capture＝bubbles しない container 発火も拾う） */
  ['variant:change', 'variant:update', 'product:variant-change', 'variantChange'].forEach(function (name) {
    document.addEventListener(name, fromDetail, true);
  });
  /* 4) Rise / Dawn の pubsub（pubsub.js は本ファイルより後の defer＝DOMContentLoaded で引く。const のため window には無い） */
  function hookPubSub() {
    try {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v && v.id != null) send(v.id, 'select');
      });
    } catch (e) {
      /* noop */
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookPubSub);
  else hookPubSub();
})();
